<template>
  <div class="flex h-full flex-col items-center justify-center">
    <h2 class="mb-3">What level of access will this new staff member need: </h2>
    <p v-if="system.external_data.bios === true">If you only need them to display on your website page select 'Profile only'</p>
    <div class="flex flex-row w-1/2">
      <div v-if="system.external_data.bios === true && system.external_data.reduced_bios === false" class="m-10 w-1/2">
        <input type="radio" id="profile" value=8 v-model="selectedType">
        <label class="text-lg" for="profile">Profile only</label>
      </div>
      <div class="m-10">
        <input type="radio" id="agent" value=5 v-model="selectedType">
        <label class="text-lg" for="agent">{{system.title}} user</label>
      </div>
    </div>
    <div class="flex flex-col w-full ">
      <div class="mb-5 flex flex-col w-full items-center">
        <p class="text-sm mb-2 w-2/5">First name:</p>
        <input class="border px-3 py-4 w-2/5" v-model="form.first_name" placeholder="First name">
      </div>
      <div class="mb-5 flex flex-col w-full items-center">
        <p class="text-sm mb-2 w-2/5">Surname:</p>
        <input class="border px-3 py-4 w-2/5" v-model="form.surname" placeholder="Surname">
      </div>
      <div class="mb-5 flex flex-col w-full items-center">
        <p class="text-sm mb-2 w-2/5">Agent Email:</p>
        <input class="border px-3 py-4 w-2/5" v-model="form.email" placeholder="Email">
      </div>
      <div v-for="(item, index) in errors" :key="index" class="mb-5 flex flex-col w-full items-center">
          <p :key="msg" class="text-red w-1/2" v-for="msg in item">{{ msg }}</p>
      </div>
      <div class="mb-5 flex flex-col w-full items-center">
        <button class="bg-grey rounded px-3 py-4 w-2/5 text-sm" @click="validateUserName" :disabled="selectedType === null" :class="{'opacity-25': selectedType === null}" ><i class="fas fa-user-plus fa-2x mx-2"></i> Add New Staff Member</button>
      </div>
      <deletion-modal
      v-if="deleteUserModal"
      @confirmed="createUser()"
      @leave="deleteUserModal = null"
      @dismissed="deleteUserModal = null"
      confirm-label="Yes, create it.">
      <p class="text-center">An account already exists for <strong>{{form.first_name}} {{form.surname}}</strong>. Are you sure you wish to create a new one?</p>
      </deletion-modal>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import { mapState } from 'vuex'
import DeletionModal from '@/components/Modals/DeletionModal'
export default {
  name: 'UserCreateModal',
  components: {
    DeletionModal
  },
  data () {
    return {
      selectedType: null,
      userTypes: null,
      loading: false,
      errors: null,
      form: {
        first_name: null,
        surname: null,
        email: null,
        type: null,
        office_id: null,
        associated_office: null
      },
      deleteUserModal: false
    }
  },
  methods: {
    createUser () {
      this.form.type = parseInt(this.selectedType)
      this.form.office_id = this.selectedOffice.id
      this.form.associated_office = [this.selectedOffice.id]
      if (this.form.type === 5) {
        this.form.assigned_offices = [this.selectedOffice.id]
      }
      api.post('/create-user', this.form).then(response => {
        if (response.status === 201) {
          console.log('user created')
          this.$emit('user-created', response.data)
        }
      }).catch(({ response }) => {
        if (response.status === 422) {
          this.errors = response.data.errors
        }
      })
    },
    validateUserName () {
      this.form.office_id = this.selectedOffice.id
      api.post('/validate-user-name', this.form).then(response => {
        if (response.data.exists) {
          this.deleteUserModal = true
        } else {
          this.createUser()
        }
      })
    }
  },
  computed: {
    ...mapState([ 'selectedOffice', 'system' ]),

    requiresApproval () {
      return this.profile.type <= 2 && this.listing.id && !this.listing.approved
    }
  }
}
</script>

<style scoped>
</style>
